"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    collapsibleVariants: ()=>collapsibleVariants
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const icongraphy_variants_cjs_namespaceObject = require("../../variants/interactions/icongraphy.variants.cjs");
const BASE_TRANSITION = '[transition-duration:var(--transition-duration-long)]';
const FOCUS_RING_STYLES = 'focus-visible:ring-primary-8 focus-visible:outline-none focus-visible:ring-2';
const BASE_HEADING_TRIGGER_STYLES = `flex cursor-pointer items-center justify-between ${FOCUS_RING_STYLES} ${BASE_TRANSITION}`;
const collapsibleVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        root: 'flex flex-col',
        elevatedRoot: `flex flex-col rounded-xl border border-transparent shadow-lg hover:shadow-xl ${BASE_TRANSITION}`,
        openElevatedRoot: 'border-primary-5 flex flex-col rounded-xl border',
        headingTrigger: `${BASE_HEADING_TRIGGER_STYLES} hover:bg-primary-2`,
        elevatedHeadingTrigger: `${BASE_HEADING_TRIGGER_STYLES} rounded-xl`,
        openElevatedHeadingTrigger: `${BASE_HEADING_TRIGGER_STYLES} hover:bg-primary-2 rounded-t-xl`,
        panel: `flex h-[var(--collapsible-panel-height)] flex-col overflow-hidden data-[ending-style]:h-0 data-[starting-style]:h-0 data-[ending-style]:opacity-0 data-[starting-style]:opacity-0 ${BASE_TRANSITION}`,
        footerTrigger: `group flex cursor-pointer items-center ${FOCUS_RING_STYLES} ${BASE_TRANSITION}`,
        footer: `text-heading6 text-actionPrimary-8 hover:text-actionPrimary-9 flex items-center hover:underline ${FOCUS_RING_STYLES} ${BASE_TRANSITION}`
    },
    variants: {
        size: icongraphy_variants_cjs_namespaceObject.sizeVariants,
        flushAligned: {
            true: {
                headingTrigger: `before:-z-1 hover:before:bg-primary-2 relative before:absolute before:inset-0 before:-mx-2 before:rounded-xl before:border-0 before:${BASE_TRANSITION}`
            }
        },
        plain: {
            true: {
                headingTrigger: 'hover:bg-primary-1 text-left'
            }
        }
    },
    defaultVariants: {
        flushAligned: false
    }
});
exports.collapsibleVariants = __webpack_exports__.collapsibleVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "collapsibleVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
